$(document).ready(function(){

  document.addEventListener('on:line-item:change', (event) => {
    var bubbles = event.detail.cart.item_count;
    console.log(bubbles);
    $('.header__cart-count-number,.cart-count').text(bubbles); 
  });
  
    /* --- Add Free Product --- */
  
	$('body').on('click', '.gift_product_button', function() {
      $('.gift-cart-product-row').toggleClass('expanded');
	});

    function addToCart(productId) {
      // Create the AJAX request
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          quantity: 1,
          id: productId,
          properties: {
			"Free Gift": "FREE GIFT"
		 }
        },
        success: function(response) {
         document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
           bubbles: true
         }));
         $.getJSON('/cart.js', function(cart, textStatus) {
            var count =cart.item_count;
            $('.header__cart-count-number,.cart-count').text(count);
         }); 
        },
        error: function(xhr, status, error) {
          console.error('Error adding product to cart:', error);
          // Handle error - display an error message, etc.
        }
      });
  }
  
	$('body').on('click', '.gift-variant-list .variant-inner ,.gift-product-single', function() {
  	  var id = $(this).attr('data-id');
      addToCart(id); 
	});

});